import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardText, CardFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import {
  isSquareConnected,
  disconnectSquarePay,
  isPaymentConnected
} from '../../axios/oauth/oauth';
import { useAuthStore } from '../../zustand-store/auth.store';
import { ROLES } from '../../constants/layout';
import DeleteModal from './DeleteModal';
const PaymentIntegrationCard = ({
  title,
  description,
  icon,
  integartionFlag,
  onClick,
  isSquareIntegrated,
  setIsSquareIntegarted
}) => {
  const [loader, setLoader] = useState(true);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);
  const locationId = useAuthStore((state) => state.locationId);
  const [squareLocationId, setSquareLocationId] = useState(null);
  const [isStripeIntegrated, setIsStripeIntegrated] = useState(false);
  const { role } = useAuthStore((state) => state);
  useEffect(() => {
    checkSquarePayConnected(locationId);
    checkStripeConnected(locationId);
  }, [integartionFlag, locationId]);
  const checkSquarePayConnected = async (locationId) => {
    let response = await isSquareConnected(locationId);
    if (response.status === 200) {
      setIsSquareIntegarted(response?.data?.data?.status);
      setSquareLocationId(response?.data?.data?.squareLocationId);
      setLoader(false);
    }
  };
  const checkStripeConnected = async (locationId) => {
    try {
      const response = await isPaymentConnected(locationId);

      if (response.status === 200) {
        const integrations = response?.data?.data || [];
        const stripeIntegration = integrations.find((item) => item.type === 'Stripe');
        const stripeActive = stripeIntegration?.isActive === true;
        setIsStripeIntegrated(stripeActive);
      }
    } catch (error) {
      setIsStripeIntegrated(false);
      setIsSquareActive(false);
    } finally {
      setLoader(false);
    }
  };
  const disconnect = async (locationId) => {
    setLoader(true);
    let response = await disconnectSquarePay(locationId);
    if (response.status === 200) {
      setIsSquareIntegarted(false);
      setLoader(false);
      setDisconnectModalOpen(false);
    }
  };
  return (
    <>
      <Card
        style={{ border: '1px solid', color: '#EFF2F7', cursor: 'pointer', height: 250 }}
        onClick={() => {
          if (!isSquareIntegrated && !isStripeIntegrated) {
            if (role == ROLES.SUPER_ADMIN || role == ROLES.PLATFORM_ADMIN) {
              onClick();
            }
          }
        }}
        id="square-integration-card">
        <CardBody>
          <div className="d-flex justify-content-between">
            <img style={{ width: '30px', height: '30px' }} src={icon} alt="" />
            {loader ? (
              <span className="text-warning">Loading...</span>
            ) : (
              <>
                {isSquareIntegrated ? (
                  <span
                    className="bg-success text-white"
                    style={{
                      fontSize: 13,
                      color: '#000',
                      background: '#F2F2F2',
                      padding: 6,
                      paddingRight: 16,
                      paddingLeft: 16,
                      borderRadius: 123
                    }}>
                    <i className="mdi mdi-check" style={{ paddingLeft: 10, paddingRight: 9 }} />{' '}
                    Connected
                  </span>
                ) : !isStripeIntegrated ? (
                  <span className="text-primary">Connect</span>
                ) : null}
              </>
            )}
          </div>
          <p
            style={{ fontSize: '13px', fontWeight: '700', color: '#000', marginTop: 14 }}
            className="mt-2">
            {title}
          </p>
          <CardText style={{ color: '#000', fontSize: '13px', fontWeight: '400', marginTop: 8 }}>
            {description}
          </CardText>
          {isSquareIntegrated && (
            <CardText style={{ color: '#74788D' }}>Location Id : {squareLocationId}</CardText>
          )}
        </CardBody>
        <CardFooter
          style={{ minHeight: '48px' }} // Ensure enough height to fit text and padding
          className="d-flex align-items-center justify-content-end py-2">
          {isSquareIntegrated && (
            <>
              {loader ? (
                <span className="text-warning" style={{ fontSize: 13 }}>
                  Loading...
                </span>
              ) : isStripeIntegrated ? (
                <span
                  className="text-muted"
                  style={{ fontSize: 13 }}
                  title="Disconnect Stripe first">
                  Disconnect
                </span>
              ) : (
                <span
                  className="text-danger"
                  style={{ cursor: 'pointer', fontSize: 13 }}
                  onClick={() => setDisconnectModalOpen(true)}>
                  Disconnect
                </span>
              )}
            </>
          )}
        </CardFooter>
      </Card>
      <DeleteModal
        show={disconnectModalOpen}
        isDeleting={loader}
        heading="Are you sure you want to disconnect Square? You will need to reconnect it to accept payments through Square again."
        componentName="Square"
        buttonTitle="Disconnect"
        onDeleteClick={() => disconnect(locationId)}
        onCloseClick={() => setDisconnectModalOpen(false)}
      />
    </>
  );
};

PaymentIntegrationCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  isIntegrated: PropTypes.string,
  icon: PropTypes.any, // replace 'any' with the actual prop type
  onClick: PropTypes.any,
  integartionFlag: PropTypes.any,
  isSquareIntegrated: PropTypes.any,
  setIsSquareIntegarted: PropTypes.any
};

export default PaymentIntegrationCard;
